import { defineAbility } from '@casl/ability';

export default function defineAbilityFor(user_perms) {
    return defineAbility((can) => {
        if ((user_perms || []).length) user_perms.map((v, i) => can(v.action, v.permission));
    });
}
